module.exports = __webpack_public_path__ + "static/media/IMG_1756.5837ca2c.jpg";